import { z } from 'zod';
import { chainNodeSchema } from '../../delegation/api/schemas';

export const userSchema = z.object({
  id: z.string(),
  phone: z.string().nullable(),
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  patronymic: z.string().nullable().optional(),
  birthDate: z.string().or(z.date()).nullable().optional(),
  citizenship: z.string().nullable().optional(),
  isVerified: z.boolean(),
  kycLevel: z.number().int().min(0).max(3),
  createdAt: z.string().or(z.date()),
  avatarUrl: z.string(),
});

export const publicUserSchema = z.object({
  id: z.string(),
  isVerified: z.boolean(),
  kycLevel: z.number().int().min(0).max(3),
  createdAt: z.string().or(z.date()),
  avatarUrl: z.string(),
});

export const authResponseSchema = z.object({
  accessToken: z.string(),
  user: userSchema,
});

export const sessionResponseSchema = z.object({
  user: userSchema,
  chain: z.array(chainNodeSchema),
  root: chainNodeSchema.nullable(),
});

export type User = z.infer<typeof userSchema>;
